// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotiek"];
